export const RESIDENT_WALLET = 'resident-wallet';

export interface Balance {
  amount: number;
  threshold_due_date: Date | null;
  negative_due_date: Date | null;
}

export function getActiveBalanceId(residentPhoenix?: {
  family_members: Array<{ primary_contact: boolean; user_id: string }>;
}): string | undefined {
  return residentPhoenix ? RESIDENT_WALLET : undefined;
}

export function getSelectedBalance(
  residentData?: {
    resident: {
      balance: Balance;
    };
  },
  selectedBalanceId?: string | null
): Balance | undefined {
  if (!selectedBalanceId || !residentData) {
    return undefined;
  }
  return residentData.resident.balance;
}
